import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { SkeletonBody, SkeletonHeadline } from '@xing-com/skeleton';
import {
  spaceL,
  spaceXL,
  spaceXXL,
  space3XL,
  space4XL,
  spaceM,
} from '@xing-com/tokens';

export const StyledHeroSkeleton = styled(SkeletonHeadline)`
  margin-bottom: ${spaceXXL};

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${spaceXL};
  }
`;

export const StyledDescriptionSkeleton = styled(SkeletonBody)`
  margin-bottom: ${spaceXL};

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${spaceL};
  }
`;

export const StyledArticlesHeadlineSkeleton = styled(SkeletonHeadline)`
  margin: ${space4XL} 0 ${spaceM};

  @media ${mediaSmallOrTiny} {
    margin: ${space3XL} 0 ${spaceM};
  }
`;

export const StyledArticlesDescriptionSkeleton = styled(SkeletonBody)`
  margin-bottom: ${spaceXXL};

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${spaceXL};
  }
`;
